import { FirestoreTournamentRepository } from "./FirestoreTournamentRepository.js";
export class OfflineClassTournamentRepository extends FirestoreTournamentRepository {
    constructor(firestore, serverTimestamp) {
        // Pass null for createMatchSQL since class tournaments don't create matches
        super(firestore, null, serverTimestamp);
        this.tournamentsRef = firestore.collection("classTournaments");
    }
    async createMatch(params) {
        // Class tournaments don't create actual matches
        return params.match_id;
    }
    async startGame(tournamentId, game) {
        // For class tournaments, we only need to update the game status
        const gameRef = this.tournamentsRef
            .doc(tournamentId)
            .collection("games")
            .doc(game.gameId);
        await gameRef.update({
            startTime: this.serverTimestamp(),
            updatedAt: this.serverTimestamp(),
        });
    }
}
